import { useState } from "react";
import banner from "../assets/images/banner-img.svg";
import apple from "../assets/images/apple.png";
import google from "../assets/images/google.png";

export default function Banner() {
  const [pos, setPos] = useState({ x: 50, y: 50 });

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    setPos({ x, y });
  };

  return (
    <div className="banner_wrapper">
      <div
        className="banner_container"
        onMouseMove={handleMouseMove}
        style={{
          background: `radial-gradient(circle at ${pos.x}% ${pos.y}%, #00E5AB , #007F5F )`,
        }}
      >
        {/* Left Content */}
        <div className="banner_left">
          <h1 className="banner_title">
            Your Parent’s Health, <br /> Your Peace of Mind
          </h1>

          <p className="banner_desc">
            Stay connected to your loved one’s care with real-time updates,
            medical visits, and emergency support — wherever you are in the
            world.
          </p>

          <div className="banner_storeRow">
            <img
              src={apple}
              alt="Download on App Store"
              className="banner_storeImg"
            />
            <img
              src={google}
              alt="Get it on Google Play"
              className="banner_storeImg"
            />
          </div>
        </div>

        {/* Right Image */}
        <div className="banner_imageWrapper">
          <img src={banner} alt="Container" className="banner_image" />
        </div>
      </div>
    </div>
  );
}
